<script lang="ts" setup>
defineProps<{
    placement: {
        top?: string
        right?: string
        bottom?: string
        left?: string
    }
}>()
</script>
<template>
    <button class="close-button" :style="placement" role="button" aria-label="close"
        @click="$emit('close')"></button>
</template>
<style lang="scss" scoped>
.close-button {
    position: absolute;
    width: rem(40);
    height: rem(40);
    background-color: var(--theme-primary-button);
    color: var(--theme-primary-button-text);
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);

    border-radius: 50%;
    outline: none;
    border: none;
    display: grid;
    align-content: center;
    cursor: pointer;
    z-index: 3;
    &:hover {
    background-color: var(--theme-primary-button-text);
    color: var(--theme-primary-button);
       
    }

    &::after {
        content: '\00D7';
        font-size: 1.5em;
    }    
}

.events-naturensuge-dk {
    .close-button {
        background-color: $dn-naturensuge-let;
        color: $dn-naturensuge-jord;

        &:hover {
            background-color: $dn-naturensuge-jord;
            color: $dn-naturensuge-lys-sand;
        }
    }
}
</style>
